export default function isRTL() {
    return document.querySelector('body').classList.contains('rtl') || document.querySelector('body').getAttribute('dir') === 'rtl';
}